import S, { DataSignal } from 's-js';
import { CaseInsensitiveStartsWith } from 'lib/diacriticals';

import { Berth } from 'data/models/Berth';

import { Typeahead } from 'portcall/typeahead/model';

export interface BerthSelectorParams {
    Berths : () => Berth[];
    SelectedBerth? : DataSignal<Berth | null>;
}

export type BerthSelector = ReturnType<typeof BerthSelector>;
export function BerthSelector({ Berths, SelectedBerth } : BerthSelectorParams) {
    const berth = SelectedBerth || S.data<Berth | null>(null),
        query = S.data(S.sample(() => berth() ? DisplayKey(berth()!) : ''));

    // If the berth changes, update the displayed query. Do this even/especially if the
    // berth changes due to some source other than the user selecting an option from the
    // typeahaed.
    S.on(berth, () => query(berth() ? DisplayKey(berth()!) : ''), undefined, true);

    return new Typeahead<Berth>({
        collection: Berths,
        matchFn: (berth : Berth, query : string) =>
            CaseInsensitiveStartsWith(DisplayKey(berth), query),
        typeaheadOptions: {
            minLength: 0,
            highlight: true,
            hint: false
        },
        observable: query,
        displayKey: DisplayKey,
        onSelect: b => berth(b)
    });
}

export function DisplayKey(berth : Berth) : string {
    const l = berth.Location(), p = l && l.Port();
    return l ? l.Name() + (p ? ` (${p.Name()})` : '') : '';
}


// WEBPACK FOOTER //
// ./apps/portcall/berthselector/model.ts